// apps/ers/src/app/modules/ers-leave-management/dialogs/leave-policy-delete-dialog/leave-policy-delete-dialog.component.ts

import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';

export interface DeleteDialogData {
  /** The name of the item being deleted — shown in red inside the message */
  itemName: string;
  /** Optional title to show in dialog */
  title?: string;
  /** Optional message (can include placeholders) */
  message?: string;
  /** Optional custom confirm button text */
  confirmText?: string;
  /** Optional custom cancel button text */
  cancelText?: string;
}

@Component({
  selector: 'ers-delete-dialog',
  standalone: true,
  imports: [
    TranslocoPipe,CommonModule, MatDialogModule],
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
})
export class DeleteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteDialogData,
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onDelete(): void {
    this.dialogRef.close(true);
  }
}
